export default __webpack_public_path__ + "static/media/diamond-2.858e1f94.webp";